import React from 'react';
import Trial from '../../sections/Bookfreetrial/Trial';
import Footer from '../../sections/Footer/Footer';
import Header from '../../sections/Header/Header';
import PGAboutUs from '../../sections/PGAboutUs/PGAboutUs';
import PGAboutUs2 from '../../sections/PGAboutUs2/PGAboutUs2';
import Scholars from '../../sections/Scholars/Scholars';
import Titlebgpic from '../../sections/Titlepic/Titlebgpic';



const AboutUs =()=>{
    return(
        <div >
          

            <Header/>
            <Titlebgpic/>
            <PGAboutUs/>
            <PGAboutUs2/>
            <Scholars/>
            <Trial/>
            <Footer/>
           
            </div>
    )
}

export default AboutUs;